<template lang="pug">
.throwdowns-leaderboard
  .leaderboard-header
    p.roboto(v-html="__(title, 'auto')")
    DynamicMedia(
      :config="headerImage"
      :style="{'max-width': imageMaxWidth+'px'}"
    )
  .leaderboard
    EmbeddedLeaderboard.embed(:competitions="competitions" :isHeaderSticky="false")
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import '@rogue/vue-strongest-leaderboard/dist/style.css'

const EmbeddedLeaderboard = defineAsyncComponent(() => import('@rogue/vue-strongest-leaderboard/dist/strongest-leaderboard.mjs').then(mod => mod.EmbeddedLeaderboard))

const props = withDefaults(defineProps<{
  title?: string | null,
  initialId?: string,
  headerImage?: object,
  imageMaxWidth?: string,
  // frameHeight consumed by RenderBlock.ts's Suspense fallback
  frameHeight?: string,
  pickList?: string,
}>(), {
  title         : null,
  initialId     : 'ri2025',
  headerImage   : () => ({}),
  imageMaxWidth : '',
  frameHeight   : '50',
  pickList      : 'ri2025|2025 Invitational,ri2024|2024 Invitational,ri2023|2023 Invitational,ri2022|2022 Invitational,ri2021|2021 Invitational',
})

type Competition = {
  id: string,
  title: string,
}

const competitions = computed<Competition[]>(() => props.pickList.split(',').map(comp => {
  const [id, title] = comp.trim().split('|')

  return { id, title }
}).sort((a, b) => a.id === props.initialId ? -1 : 1))
</script>

<style lang="scss" scoped>
.leaderboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  margin: 0 auto;

  .media-wrap {
    display: inline-block;
  }

  p {
    margin-bottom: 0;
    display: inline;
  }
}

.leaderboard {
  position: relative;
  margin: 0 auto;
  max-width: 100%;
  font-size: 16px;

  @media(min-width: $desktop) {
    margin: 0 auto 3em;
  }

  .embed {
    width:100%;
    border: none;
    min-height: 800px;
  }
}
</style>
